module.exports = __webpack_public_path__ + "img/profile-img.14401d88.png";